module.exports = __webpack_public_path__ + "img/yabanci-uyruklu-saglik-sigortasi.cdbe5d7d.png";